import { render } from "./PatientList.vue?vue&type=template&id=9ffaf444&ts=true"
import script from "./PatientList.vue?vue&type=script&lang=ts"
export * from "./PatientList.vue?vue&type=script&lang=ts"

import "./PatientList.vue?vue&type=style&index=0&id=9ffaf444&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__